import * as React from "react";
import { Grid, Typography } from "components/controls/widget";
import { hasFlag, formatDate } from "components/state/types";
import { MemberApplication, MemberApplicationFormState } from "../entity";
import { getAddress } from "./address";

interface Props {
    application: MemberApplication;
}

const View = ({ application }: Props) => {

    const { surname, name, title, email, sex, birthDate, mobilePhone, personalIdNumber, countryName, homeAddress, postAddress } = application.member;
    const pohlavi = sex === 'F' ? "Žena" : "Muž";
    const celeJmeno = (title ? title + ' ' : '') + name + ' ' + surname;
    const showPostAddress = !hasFlag(application.formFlags, MemberApplicationFormState.MemberPostAddressIsSameAsHome);

    return <Grid container>
        <Grid item sm={12}>
            <Typography variant="h6">{"Přihlašovaný člen: " + celeJmeno}</Typography>
        </Grid>

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Adresa bydliště: ' + getAddress(homeAddress)}</Typography>
        </Grid>

        {showPostAddress && <Grid item sm={12}>
            <Typography variant="subtitle1">{'Korespondenční adresa: ' + getAddress(postAddress)}</Typography>
        </Grid>}

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Email: ' + email}</Typography>
        </Grid>

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Telefon: ' + mobilePhone}</Typography>
        </Grid>

        {personalIdNumber && <Grid item sm={12}>
            <Typography variant="subtitle1">{'Rodné číslo: ' + personalIdNumber}</Typography>
        </Grid>}

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Pohlaví: ' + pohlavi}</Typography>
        </Grid>

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Datum narození: ' + formatDate(birthDate)}</Typography>
        </Grid>

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Státní příslušnost: ' + countryName}</Typography>
        </Grid>
    </Grid >
}

export {
    View as MemberView,
}